import React from 'react';
import { TableCell, CircularProgress, Chip } from '@mui/material';
import { format } from 'date-fns';
import formatFileSize from '../formatFileSize';

const StatusChip = ({ value }) => {
    let colour = 'info';

    switch (value) {
        case 'Draft':
        case 'Scheduled':
            colour = undefined;
            break;
        case 'Published':
        case 'Sent':
            colour = 'success';
            break;
    }

    return (
        <Chip
            label={value}
            color={colour}
            size="small"
        />
    );
};

const renderValue = (dataType, value) => {
    if (dataType === 'boolean') return value ? 'Yes' : 'No';
    if (dataType === 'number') return new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 }).format(value ?? 0);
    if (dataType === 'filesize') return value ? formatFileSize(value) : '0 B';
    if (dataType === 'status') return <StatusChip value={value} />;
    if (!value) return '-';
    if (dataType === 'dateTime') return format((new Date(value)), 'dd/MM/yyyy HH:mm');

    return value;
};

const DataColumn = ({ value, dataType, align, nowrap = false, onClick = null, cursor = 'default', isLoading = false }) => {
    const renderedValue = renderValue(dataType, value);

    return (
        <TableCell
            align={align}
            onClick={onClick}
            sx={{
                cursor: cursor,
                whiteSpace: nowrap ? 'nowrap' : undefined
            }}
        >
            {isLoading ? <CircularProgress size={14} color="inherit" /> : renderedValue}
        </TableCell>
    );
};

export default DataColumn;